import ReValidate from './../re-validation'
import props from './../../../../props/inputs'

export default {
  name: 're-radio',
  components: {[ReValidate.name]: ReValidate},
  props: {
    ...props,
    value: {
      type:[String, Boolean, Number, Array, Object],
      default: false
    },
    radioValue: {
      type: [String, Number],
      default: null
    },
    label: {
      type: String,
      default: "Select"
    },
    inputClass: {
      type: String,
      default: ''
    },
  },

  computed: {
    radioId() {
      return this.id || 'radio_'+Math.floor(100 * Math.random())+this.name
    },
    isChecked() {
      return this.value == this.radioValue
    }
  },
  methods: {
    onInput(event) {
      const value = event.target.value
      this.$emit('input', value)
    }
  }
}
